import script from "./header.vue?vue&type=script&setup=true&lang=ts"
export * from "./header.vue?vue&type=script&setup=true&lang=ts"

import "./header.vue?vue&type=style&index=0&id=33d53b41&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d53b41"]])

export default __exports__